import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { useContext } from 'react';
import { Routes, BrowserRouter, Route as RouterRoute } from 'react-router-dom';
import ScrollToTop from '../../utils/ScrollToTop';
import UrlParamsHelper from '../../utils/urlParams/urlParamsHelper';
import { ReloadOnVersionChange } from '../../utils/ReloadOnVersionChange';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/* Context */
export var RouteContext = /*#__PURE__*/React.createContext({});

/* Helper */
var urlParamsHelper = new UrlParamsHelper();

/**
 * Global Route variant provider
 *
 **/
var RouteProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(RouteProvider, _React$Component);
  var _super = _createSuper(RouteProvider);
  function RouteProvider(props) {
    var _this;
    _classCallCheck(this, RouteProvider);
    _this = _super.call(this, props);
    /**
     * Generates a path string
     * @param {string} locale The locale prefix
     * @param {string} path   The actual path
     */
    _this.generatePath = function (path) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';
      var host = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return path['global'] ? "".concat(path['global']) : "".concat(host ? host : '').concat(locale && '/').concat(locale).concat(path[locale]);
    };
    /**
     * Registers a route
     */
    _this.registerRoute = function (id, path) {
      _this.setState(_extends({}, _this.state, {
        routes: _extends({}, _this.state.routes, _defineProperty({}, id, path || null))
      }));
    };
    /**
     * Renders the children
     * @param {Children}            Children  The Children
     * @param {testimonialVariant}  variant   The childrens variant
     * @return  {Children}
     **/
    _this.renderRoutes = function () {
      return React.Children.map(_this.props.children, function (child) {
        return child && _typeof(child) === 'object' && 'props' in child && !child.props.staticPath ? /*#__PURE__*/React.cloneElement(child, {
          path: _this.generatePath(child.props.path, _this.state.locale)
        }) : undefined;
      });
    };
    _this.packagesToWatchForVersionChange = {
      'pc-matching': ['app'],
      'bc-dashboard': ['app']
    };
    _this.Router = _this.props.router || BrowserRouter;
    var STAGE = process.env.REACT_APP_STAGE === 'prod' ? 'www' : 'stage';
    var _host = "https://".concat(STAGE, ".truck-jobs.com");
    var routes = {
      // Default routes, that lead to the core jmm system
      pcreg: "".concat(_host, "/employee/jobsearch").concat(props.locale && '?locale=' + props.locale),
      bcreg: "".concat(_host, "/employer/registration").concat(props.locale && '?locale=' + props.locale),
      imprint: "".concat(_host, "/imprint/"),
      legal: "".concat(_host, "/legal/"),
      privacy: "".concat(_host, "/privacy/"),
      faq: "".concat(_host, "/de/faqs/"),
      bcfaq: "https://jobmatch.me/de/arbeitgeber/haeufige-fragen-zu-jobmatchme/",
      news: "".concat(_host, "/de/wissen/"),
      newsPc: "".concat(_host, "/de/wissen/fahrer/"),
      newsBc: "".concat(_host, "/de/wissen/arbeitgeber/"),
      pcPage: "".concat(_host, "/").concat(props.locale, "/"),
      bcPage: "".concat(_host, "/de/arbeitgeber/"),
      successStoriesList: "".concat(_host, "/de/erfahrungen/"),
      carePcLogin: "".concat(_host, "/de/jobs/pflege/suche/login/"),
      pl_pcLogin: "/pl/login/",
      de_pcLogin: "/de/login/",
      at_pcLogin: "/de/login/",
      pl_bcLogin: "/pl/pracodawca/app/login/",
      de_bcLogin: "/de/arbeitgeber/app/login/",
      at_bcLogin: "/de/arbeitgeber/app/login/"
    };

    // We need to prefix the routes with the locale, if given
    React.Children.map(props.children, function (route) {
      routes[route.props.id] = route.props.path ? _this.generatePath(route.props.path, props.locale, route.props.host).replace('*', '') : null;
    });
    _this.state = {
      locale: props.locale,
      routes: routes
    };
    urlParamsHelper.saveGetParamsToLocalStorage();
    urlParamsHelper.cleanupUrlParams();
    return _this;
  }
  _createClass(RouteProvider, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx(this.Router, {
        location: this.props.location,
        children: /*#__PURE__*/_jsx(RouteContext.Provider, {
          value: _extends({}, this.state.routes, {
            _locale: this.state.locale
          }),
          children: /*#__PURE__*/_jsx(ReloadOnVersionChange, {
            packagesWithRoutes: this.packagesToWatchForVersionChange,
            packageVersions: this.props.packageVersions,
            children: /*#__PURE__*/_jsx(ScrollToTop, {
              children: /*#__PURE__*/_jsxs(Routes, {
                children: [this.renderRoutes(), !this.props.no404 && /*#__PURE__*/_jsx(Route, {
                  path: "*",
                  children: this.props.notFoundPage || null
                })]
              })
            })
          })
        })
      });
    }
  }]);
  return RouteProvider;
}(React.Component);
/**
 * Custom route component
 * @param {string}  id    The identifier for the route
 * @param {string}  path  The path to route to
 */
export var Route = RouterRoute;

/**
 * The consumer component for the RouteContext
 **/
export var RouteConsumer = RouteContext.Consumer;

/**
 * HOC that provides the globalApplicationRoutes Prop
 */
export var withRoutes = function withRoutes(Component) {
  return function (props) {
    return /*#__PURE__*/_jsx(RouteConsumer, {
      children: function children(routes) {
        return /*#__PURE__*/_jsx(Component, _extends({
          applicationRoutes: routes,
          getUrlParams: urlParamsHelper.getUrlParamsFromLocalStorage
        }, props));
      }
    });
  };
};
export var useApplicationRoutes = function useApplicationRoutes() {
  return useContext(RouteContext);
};
export default RouteProvider;